import { type Point, type Rect, toRect } from "./geometry";

export interface ContextMenuAnchor {
  point: Point;
  /** Set when opened from the keyboard: the menu goes below the element. */
  rect: Rect | null;
  /** Receives focus back when the menu closes. */
  returnFocus: HTMLElement | null;
  /** Changes on every open, so a second right-click re-positions the menu. */
  openId: number;
}

export interface ContextMenuState<T> extends ContextMenuAnchor {
  target: T;
}

/** Where to open a menu; `rect` and `returnFocus` are optional when opening at a pointer. */
export interface OpenRequest {
  point: Point;
  rect?: Rect | null;
  returnFocus?: HTMLElement | null;
}

/** Opens below `element` and gives focus back to it on close (keyboard openings). */
export function belowElement(element: HTMLElement): OpenRequest {
  const r = element.getBoundingClientRect();
  return { point: { x: r.left, y: r.bottom }, rect: toRect(r), returnFocus: element };
}
